var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_63960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 350
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1009_63960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.667 262.5H233.333V233.333H116.667V262.5ZM116.667 204.167H233.333V175H116.667V204.167ZM87.5002 320.833C79.4793 320.833 72.613 317.977 66.9012 312.265C61.1894 306.554 58.3335 299.687 58.3335 291.667V58.3332C58.3335 50.3123 61.1894 43.446 66.9012 37.7342C72.613 32.0224 79.4793 29.1665 87.5002 29.1665H204.167L291.667 116.667V291.667C291.667 299.687 288.811 306.554 283.099 312.265C277.387 317.977 270.521 320.833 262.5 320.833H87.5002ZM189.583 131.25V58.3332H87.5002V291.667H262.5V131.25H189.583Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPreview);
export default __webpack_public_path__ + "static/media/DocumentPreview.9be5f1b54f6558a5964b8eb3acd1ab4a.svg";
export { ForwardRef as ReactComponent };